import React, { useState } from 'react';
import { RichText } from 'prismic-reactjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import htmlSerializer from '../utils/htmlSerializer';

const FaqItem = ({ title, text }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className='my-4 rounded bg-gray-100 text-primary shadow'>
      <button
        type='button'
        onClick={() => setIsOpen(!isOpen)}
        className='flex w-full cursor-pointer items-center justify-between px-3 py-3 text-left'
        aria-expanded={isOpen}
      >
        <span className='text-lg font-semibold'>
          {RichText.asText(title.raw)}
        </span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className='text-sm text-gray-400 transition-transform duration-200'
          style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}
          aria-hidden
        />
      </button>
      {isOpen && (
        <div className='px-3 pb-3'>
          <RichText render={text.raw} htmlSerializer={htmlSerializer} />
        </div>
      )}
    </div>
  );
};

export default FaqItem;
